// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class WarehouseItemGroupResource extends Resource {
    basePath: string = 'warehouse/item-groups/';

    objectPath: string = 'warehouse/item-groups/{ident}/';

    exportItemGroups(data: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}export_item_groups/`,
            'POST', data,
        );
    }
}
